<template>
	<Dropdown v-model="$i18n.locale" :options="languagues" optionLabel="name" optionValue="code" @change="onLanguageChange($event)"/>
</template>

<script>
export default {
	data: function() {
		return {
			languagues: [
				{ name: "Italiano", code: "it" },
				{ name: "English", code: "en" },
				{ name: "Español", code: "es" },
				{ name: "Català", code: "ca" },
                { name: "Français", code: "fr" },
                { name: "Português", code: "pt" },
                { name: "Deutsch", code: "de" }
			]
		};
    },
    methods: {
        onLanguageChange(event){
            localStorage.setItem('i18Locale', event.value); // store value in cookie
            this.$emit("languageChanged");
		}
    }
};
</script>